// ============================================================
// pagoPage.js — Página de pago / checkout
// ============================================================
import { qs, qsa, on } from './utils.js';
import { toast } from './toast.js';

const PLANS = {
  suscripcion: {
    name: 'Suscripción Vimo',
    priceMonth: { ES_LATAM: 29.90, BR: 19.90 },
    priceYear: { ES_LATAM: 23.90, BR: 15.90 },
    currency: { ES_LATAM: '$', BR: '$' },
    features: [
      'Generación de vídeos ilimitada',
      'Generación de imágenes con IA de alta calidad',
      'Acceso completo a avatares HeyGen',
      'Clonación de voz ultra-realista con ElevenLabs',
      'Resolución en alta definición (HD/4K)',
      'Acceso prioritario a nuevos modelos',
      'Soporte premium 24/7',
    ],
  },
};

const VAT = 0.21;

export function initPagoPage() {
  if (document.body.dataset.page !== 'pago') return;

  const params  = new URLSearchParams(window.location.search);
  let billing   = params.get('billing') || 'month';

  const plan = PLANS.suscripcion;

  // Detectar la región del usuario logueado
  const user = JSON.parse(localStorage.getItem('vimo_user') || '{}');
  const region = user.region || 'ES_LATAM';

  // Plan name (sidebar on desktop + mobile header in form section)
  [qs('#pagoSummaryPlan'), qs('#pagoSummaryPlanMobile')].forEach(el => {
    if (el) el.textContent = plan.name;
  });

  // Features list (sidebar on desktop + mobile extras in form section)
  const featuresHtml = plan.features
    .map(f => `<li class="pago-includes-item"><i class="bi bi-check-lg" aria-hidden="true"></i>${f}</li>`)
    .join('');
  const featuresList = qs('#pagoFeaturesList');
  if (featuresList) featuresList.innerHTML = featuresHtml;
  const featuresListMobile = qs('#pagoFeaturesListMobile');
  if (featuresListMobile) featuresListMobile.innerHTML = featuresHtml;

  // Billing switcher
  const updateBilling = () => {
    qsa('.pago-billing-opt').forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.billing === billing);
    });
    updatePrices();
  };

  on(document, 'click', '.pago-billing-opt', (_e, btn) => {
    billing = btn.dataset.billing;
    updateBilling();
  });

  function updatePrices() {
    const isYear  = billing === 'year';
    const currency = plan.currency[region] || '€';
    const priceMonth = plan.priceMonth[region] || plan.priceMonth.ES_LATAM;
    const priceYear = plan.priceYear[region] || plan.priceYear.ES_LATAM;

    const base    = isYear ? priceYear * 12 : priceMonth;
    // En Brasil no se aplica el IVA del 21%
    const vatRate = region === 'BR' ? 0 : VAT;
    const vat     = base * vatRate;
    const total   = base + vat;
    const fmt     = n => n.toFixed(2).replace('.', ',') + ' ' + currency;
    const zero    = '0,00 ' + currency;

    const labelEl    = qs('#pagoPriceLabel');
    const strikeEl   = qs('#pagoPriceStrike');
    const baseEl     = qs('#pagoPriceBase');
    const vatEl      = qs('#pagoVatAmount');
    const totalEl    = qs('#pagoTotalAmount');
    const discountEl = qs('#pagoDiscountBadge');
    const afterEl        = qs('#pagoTrialAfter');
    const afterShortEl   = qs('#pagoTrialAfterShort');
    const afterMobileEl  = qs('#pagoTrialAfterMobile');

    if (labelEl)   labelEl.textContent  = isYear
      ? `${priceYear.toFixed(2).replace('.', ',')} ${currency} × 12 meses`
      : `${fmt(priceMonth)} al mes`;
    if (strikeEl)  strikeEl.textContent = fmt(base);
    if (baseEl)    baseEl.textContent   = zero;
    if (vatEl)     vatEl.textContent    = zero;
    if (totalEl)   totalEl.textContent  = zero;
    if (discountEl) discountEl.hidden   = !isYear;
    const afterText = isYear ? `${fmt(base)}/año` : `${fmt(base)}/mes`;
    if (afterEl)       afterEl.textContent       = afterText;
    if (afterShortEl)  afterShortEl.textContent  = afterText;
    if (afterMobileEl) afterMobileEl.textContent = afterText;
  }

  updateBilling();

  // Payment method tabs
  on(document, 'click', '.pago-method-tab', (_e, tab) => {
    const key = tab.dataset.tab;
    qsa('.pago-method-tab').forEach(t => t.classList.remove('is-active'));
    tab.classList.add('is-active');

    qsa('.pago-panel').forEach(p => p.classList.add('is-hidden'));
    const id = 'pagoTab' + key.charAt(0).toUpperCase() + key.slice(1);
    qs('#' + id)?.classList.remove('is-hidden');
  });

  // Form submit
  qs('[data-pago-form]')?.addEventListener('submit', e => {
    e.preventDefault();
    // TODO backend: POST /api/checkout { plan: planKey, billing, formData }
    toast({ message: '¡Suscripción activada! Bienvenido a Vimo.', type: 'success' });
    setTimeout(() => { window.location.href = 'escritorio.html'; }, 1200);
  });
}
